<div class="row">
    @if (permissions.CanOpenDi) {
        <div class="col-12 col-xl-6">
            <div class="detail-page-card">
                <div class="detail-page-card-title">{{ 'controls.testResult.diScoringTitle' | transloco }}</div>
                <div class="detail-page-card-body padded cerrix-control-sm">
                    @if (permissions.CanOpenAdvEff) {
                        <div style="width: 100%; height: 47px"></div>
                    }
                    <control-testscore-chart #diChart></control-testscore-chart>
                </div>
            </div>
        </div>
    }
    @if (permissions.CanOpenSimpleEff || permissions.CanOpenAdvEff) {
        <div class="col-12 col-xl-6">
            <div class="detail-page-card">
                <div class="detail-page-card-title">{{ 'controls.testResult.effectivenessScoringTitle' | transloco }}</div>
                <div class="detail-page-card-body padded cerrix-control-sm">
                    @if (permissions.CanOpenSimpleEff) {
                        <control-testscore-chart #effSimple></control-testscore-chart>
                    }
                    @if (permissions.CanOpenAdvEff) {
                        <control-adv-eff-chart #effAdv></control-adv-eff-chart>
                    }
                </div>
            </div>
        </div>
    }
</div>
